import _ from 'lodash';
import type { Brief } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { convertDollarToCents } from '../../utils';
import { HIGH_BUDGET_THRESHOLD_DOLLARS } from '../BriefCreationContext.constants';
import { getMaxBudgetInCentsFromBrief } from './getMaxBudgetInCentsFromBrief';

interface HighSpendExperienceArgs {
    brief?: Brief;
    inJpHighSpendExperience: boolean;
}

interface BudgetSectionContent {
    pricingType?: Gql.BriefPricingType | null;
}

const isHourlyPricingSelected = (brief?: Brief): boolean => {
    const budgetSection = brief?.sections?.find(
        (section) => section.id === 'budget' || section.id === 'budget_and_timeline'
    );
    const content = budgetSection?.content as BudgetSectionContent | undefined;

    return content?.pricingType === Gql.BriefPricingType.Hourly;
};

export const isHighSpendExperience = ({ brief, inJpHighSpendExperience }: HighSpendExperienceArgs) => {
    if (inJpHighSpendExperience) {
        return true;
    }
    if (isHourlyPricingSelected(brief)) {
        return true;
    }

    const maxBudgetInCents = getMaxBudgetInCentsFromBrief(brief);
    const thresholdInCents = convertDollarToCents(HIGH_BUDGET_THRESHOLD_DOLLARS);

    return !_.isNil(maxBudgetInCents) && maxBudgetInCents >= thresholdInCents;
};
